














































































import { gsap } from "gsap";
import TheStickyFooterButton from "@/common/components/organisms/TheStickyFooterButton.vue";
import FormSearch from "@/common/components/atoms/FormSearch.vue";
import ButtonRefine from "@/common/components/atoms/ButtonRefine.vue";
import ButtonRefineBase from "@/common/components/atoms/ButtonRefineBase.vue";
import ValidationErrorText from "@/common/components/atoms/ValidationErrorText.vue";
import { Prop, Vue, Component, Watch } from "vue-property-decorator";
import globals from "@/general/store/modules/globals";
import modalState from "@/common/store/modules/modalState";
import { getThanksPointName } from "@/common/assets/js/utils/pointName";
import SITE_MAP from "@/general/mixins/const/custom/sitemap";
import CONST_DATA from "@/general/mixins/const/constData";

@Component({
  components: {
    TheStickyFooterButton,
    FormSearch,
    ButtonRefine,
    ButtonRefineBase,
    ValidationErrorText
  }
})
export default class TheTemplateJ extends Vue {
  @Prop({ type: [String, Boolean], default: false, required: true })
  heading!: string;
  @Prop({ type: Array, default: ["search", "button"] }) indicatedItem!: Array<
    string
  >;
  @Prop({ type: String, default: "検索" }) searchPlaceholder!: string;
  @Prop({ type: String, default: "" }) searchKeyword!: string;
  @Prop({ type: Boolean, default: false }) initShownSearchFormState!: string;
  @Prop({
    type: Object,
    default: () => {
      return {
        target: "username-asc",
        shownState: false,
        itemList: []
      };
    }
  })
  sorted!: any;
  @Prop({ type: String, default: "並べ替え" }) filterHeading!: string;
  @Prop({ type: String, default: null }) errorMessage!: string;

  isSp = globals.isSpScreenWidth;
  closeModalState = modalState.closeModalState;

  fadeOutState = false;
  searchUriBase = ["/j03/", "/j04/"];

  executeSearchFormDomAnimation = false;
  shownSearchFormState = true;
  searchFormClassName = "p-the-template-j__search--animation";

  serchFormStyle = {
    visibility: "hidden",
    opacity: 0
  };

  get url() {
    return SITE_MAP.THANKS_POINT_USER_SELECTION;
  }

  get search() {
    return this.searchKeyword;
  }

  set search(value) {
    this.searchKeyword = value;
  }

  get indicateSearchForm() {
    const indicatedItem = this.indicatedItem;
    const keyword = "search";
    return indicatedItem.includes(keyword);
  }

  get indicateSearchButton() {
    const indicatedItem = this.indicatedItem;
    return indicatedItem.includes("searchButton");
  }

  get indicateSortedButton() {
    const indicatedItem = this.indicatedItem;
    const keyword = "sorted";
    return indicatedItem.includes(keyword);
  }

  get contentElementStyle() {
    const executeSearchFormDomAnimation = this.executeSearchFormDomAnimation;
    let styleObject = {};

    if (executeSearchFormDomAnimation === false) {
      styleObject = {
        marginTop: 0
      };
    }

    return styleObject;
  }

  get indicateNewAddButton() {
    const indicatedItem = this.indicatedItem;
    const keyword = "button";
    return indicatedItem.includes(keyword);
  }

  get widthRefineButton() {
    return "170px";
  }

  get thanksPointName() {
    return getThanksPointName(CONST_DATA.POINT_NAME.THANKS_POINT_DEFAULT_NAME1);
  }

  @Watch("isSp")
  onIsSp() {
    this.initSearchFormDomAnimation();
  }

  @Watch("shownSearchFormState")
  onShownSearchFormState() {
    this.animationSearchFormDom(this.$refs.searchFormElement);
  }

  mounted() {
    this.initDomElement();
  }

  initDomElement() {
    const initShownSearchFormState = this.initShownSearchFormState;
    this.initSearchFormDomAnimation();

    if (initShownSearchFormState) {
      this.animationSearchFormDom(this.$refs.searchFormElement);
    }
  }

  fadeOutNewAddButton() {
    const scrollY = window.scrollY;
    const windowHeight = window.innerHeight;
    const documentHeight = document.documentElement.scrollHeight;
    const triggerPosition = documentHeight - windowHeight;

    this.fadeOutState = scrollY === triggerPosition;
  }

  doSearch() {
    this.$emit("do-search", this.search);
  }

  doSort($event: any) {
    this.$emit("do-sort", $event);
  }

  switchSortedState(value: any) {
    this.sorted.shownState = value;
  }

  switchSearchFormState() {
    this.shownSearchFormState = !this.shownSearchFormState;
  }

  initSearchFormDomAnimation() {
    const isSp = this.isSp;
    const indicateSearchButton = this.indicateSearchButton;
    const executeSearchFormDomAnimation = isSp && indicateSearchButton;

    this.executeSearchFormDomAnimation = executeSearchFormDomAnimation;
    this.shownSearchFormState = !executeSearchFormDomAnimation;
  }

  animationSearchFormDom(el: any, shown = this.shownSearchFormState) {
    const executeSearchFormDomAnimation = this.executeSearchFormDomAnimation;
    const { contentElement } = this.$refs;
    const speed = 0.2;

    const animationStyle = {
      formSearchElement: {
        autoAlpha: shown ? 1 : 0
      },
      contentElement: {
        marginTop:
          shown && executeSearchFormDomAnimation ? `${60 / 16}rem` : "0rem"
      }
    };

    gsap.to(el, speed, animationStyle.formSearchElement);
    gsap.to(contentElement, speed, animationStyle.contentElement);
  }
}
